const initialState = {
  isProfA1DataLoaded: false,
  paroleRegion: {
    id: '',
    value: '',
  },
  SAT: {
    id: '',
    value: '',
  },
  CDCNumber: '',
  countyofLastLegalResidence: '',
  participant: {
    participantID: '',
    participantName: '',
    DOB: '',
    ethnicGroupId: '',
  },
  maritalStatusId: '',
  empStatus: '',
  highestEducationId: '',
  CSRAScore: '',
  ASIScore: '',
  secondaryScore: '',
  permanentAddress: '',
  permanentCity: '',
  permanentZipCode: '',
  permanentTelephone: '',
  veteran: '',
  ADA: '',
  usualOccupation: '',
  years: '',
  numberofChildren: '',
  Ages: '',
  isCSBOrCPSInvolved: '',
  childrenLiveWith: '',
  emergencyContact1Name: '',
  emergencyContact1Address: '',
  emergencyContact1City: '',
  emergencyContact1Phone: '',
  emergencyContact1Relationship: '',
  emergencyContact2Name: '',
  emergencyContact2Address: '',
  emergencyContact2City: '',
  emergencyContact2Phone: '',
  emergencyContact2Relationship: '',
  everDiagnosedwithMentalHealthIssue: '',
  historyofSuicideAttemptsPsychIssuesReportedbyPart: '',
  classifiedCCCMS: '',
  classifiedCCCMSYear: '',
  classifiedCCCMSClearedYear: '',
  medComments: '',
  medicineName1: '',
  medicineCondition1: '',
  medicineName2: '',
  medicineCondition2: '',
  medicineName3: '',
  medicineCondition3: '',
  primaryLanguage: '',
};

export default initialState;
